import React from "react";
import { Turnstile } from "@marsidev/react-turnstile";

// Cloudflare Turnstile widget. Renders nothing if no site key is configured,
// so the app still works in environments without Turnstile set up.
export const TurnstileField = ({ onToken, className = "" }) => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  if (!siteKey) return null;

  return (
    <div className={className} data-testid="turnstile-widget">
      <Turnstile
        siteKey={siteKey}
        options={{ theme: "light" }}
        onSuccess={(token) => onToken(token)}
        onExpire={() => onToken("")}
        onError={() => onToken("")}
      />
    </div>
  );
};

export default TurnstileField;
